import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { PagedData } from '../models/paging/paged-data';

export class WpQuery {
  page?: number = 1;
  perPage?: number = 100;
  hideEmpty?: boolean;
  search?: string;
  orderBy?: string;
  order?: string;
  fields?: string; // "_fields"
  context?: string = "embed";
  extraParams?: { [key: string]: string };
}

export class WpCategory {
  id: number;
  name: string;
  slug: string;
}

export class WpPost {
  id: number;
  title: { rendered: string };
  content: { rendered: string };
  categories?: number[];
  _embedded?: {
    'wp:featuredmedia'?: Array<{
      source_url: string;
      alt_text: string;
    }>;
    'author'?: Array<{
      id: number;
      name: string;
    }>;
  };
  link?: string;
  date?: string;
  modified?: string;
  status?: string;
}

@Injectable({
  providedIn: 'root'
})
export class WordpressService {
  private baseUrl = environment.apiWordpress;

  constructor(private http: HttpClient) { }

  /**
   * Get WordPress categories
   * @param query Query parameters for filtering categories
   * @returns Observable of categories array
   */
  getCategories(query: WpQuery) {
    return this.http.post<PagedData<WpCategory>>(`${this.baseUrl}/GetCategories`, query);
  }

  /**
   * Get WordPress posts
   * @param query Query parameters for filtering posts
   * @returns Observable of posts array
   */
  getPosts(query: WpQuery) {
    return this.http.post<PagedData<WpPost>>(`${this.baseUrl}/GetPosts`, query);
  }
}
